import { useState } from 'react';
import { redeemCode } from '../lib/api';

export function useRedeem() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('');

  async function redeem(email: string, code: string) {
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      const result = await redeemCode(email, code);
      setSuccess(true);
      setMessage(result.message);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Redemption failed');
    } finally {
      setLoading(false);
    }
  }

  return { redeem, loading, error, success, message };
}
